import React from "react";
import { TRUST_POINTS, IMAGES } from "@/lib/content";
import { ShieldCheck, Award, Compass, Scale } from "lucide-react";

const ICONS = [ShieldCheck, Award, Compass, Scale];

const TrustGrid = () => {
  return (
    <section
      data-testid="trust-section"
      className="relative bg-[#0B0410] text-[#F9F6F0] py-24 lg:py-32 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-20 bg-cover bg-center"
        style={{ backgroundImage: `url(${IMAGES.servicesBg})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B0410] via-[#0B0410]/85 to-[#0B0410]" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#E6D5B8]" />
            <span className="text-[11px] tracking-luxury uppercase text-[#E6D5B8] font-medium">
              ¿Por qué EMB?
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.08]">
            La diferencia está en cómo{" "}
            <span className="italic text-[#E6D5B8]">trabajamos</span>.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          {TRUST_POINTS.map((t, idx) => {
            const Icon = ICONS[idx % ICONS.length];
            return (
              <div
                key={t.title}
                data-testid={`trust-point-${idx}`}
                className="bg-[#0B0410] p-8 lg:p-10 group hover:bg-[#150A1F] transition-colors duration-500"
              >
                <Icon size={22} className="text-[#E6D5B8] mb-6" />
                <h3 className="font-display text-2xl lg:text-3xl font-light">
                  {t.title}
                </h3>
                <p className="mt-4 text-sm text-[#F9F6F0]/70 leading-relaxed font-light">
                  {t.detail}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustGrid;
